angular.module('pubnub.angular.service', []).provider('PubNub', function() {

    this.$get = function() {
        return PUBNUB;
    }
});
